/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    operators: {
        menu: {
            index: 'Operators',
            create: 'New',
            list: 'Operators'
        },
        table_titles: {
            id: 'ID',
            name: 'Name',
            is_individual: 'Operator type',
            country: 'Country',
            setting: 'Edit / Delete',
        },
        edit: 'Edit operator'
    }
}
